/**
 * Palettes theme values.
 */
import { Palettes } from "@oui/system/palettes"
import colors from "./colors"

const palettes: Palettes = {
  default: {
    light: colors.grays[0],
    main: colors.grays[1],
    dark: colors.grays[3],
    text: colors.black
  },
  primary: {
    light: colors.blues[0],
    main: colors.blues[2],
    dark: colors.blues[3],
    text: colors.black
  },
  secondary: {
    light: colors.grays[0],
    main: colors.grays[1],
    dark: colors.grays[3],
    text: colors.black
  },
  tertiary: {
    light: colors.grays[0],
    main: colors.grays[1],
    dark: colors.grays[3],
    text: colors.black
  },
  success: {
    light: colors.greens[0],
    main: colors.greens[2],
    dark: colors.greens[3],
    text: colors.black
  },
  warning: {
    light: colors.oranges[0],
    main: colors.oranges[2],
    dark: colors.oranges[3],
    text: colors.black
  },
  danger: {
    light: colors.warmReds[0],
    main: colors.warmReds[2],
    dark: colors.warmReds[3],
    text: colors.black
  },
  info: {
    light: colors.teals[0],
    main: colors.teals[2],
    dark: colors.teals[3],
    text: colors.black
  },
  unavailable: {
    light: colors.grays[4],
    main: colors.grays[7],
    dark: colors.grays[8],
    text: colors.white
  }
}

export default palettes
